export const IDRFormat = (x: number) => new Intl.NumberFormat("id-ID", {style: "currency", currency: "IDR", maximumFractionDigits: 0}).format(x);

export const capitalizeFirstLetter = (oldString: string) => {
  const temp = oldString.toLowerCase()
  const words = temp.split(' ')
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].slice(1);
  }
  return words.join(' ')
}